exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-app {\n  border-radius: 0px 0px 0px 50px;\n}\n.container-app .store-link {\n  max-width: 100px;\n}\n@media only screen and (min-width: 1024px) {\n.app-links {\n    background: linear-gradient(90deg, #1C4C91 0%, #3A91F9 100%);\n}\n}\n.text-blue-250 {\n  color: #9BC9FF;\n}\n.mb--6 {\n  margin-bottom: -1.5em;\n}\n.bg-jblue-footer {\n  background-color: #1C4C91;\n}\n.register-footer .list-footer-bottom {\n  padding-right: 2.5rem;\n}\n.register-footer .list-footer-social {\n  margin-right: 2.5rem;\n}\n.register-footer .app-links {\n  margin-right: 2.5rem;\n  padding: 5px;\n}", ""]);

// exports
